module.exports = __webpack_public_path__ + "img/codepay2.e4925f70.jpg";